import {List, Map} from 'immutable';
import defaultDialogReducer from '../../defaultDialogReducer';
import {dialogsNames} from '../../../enums/dialogsNames';
import { actionTypes as actionTypes }  from '../../../actions/Dialogs/SlitRollsToCassettesDialog/slitRollsToCassettesDialogActions';

let defaultState = {
  loading: false,
  show: false,
  preselectedAssets: List(),
  items: null,
};

export default function(state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.SLIT_ROLLS_TO_CASSETTES_SHOW:
      return state.set('preselectedAssets', action.payload?.map((item) => _convertAssetDataToDialogItem(item)) ?? List())
        .set('show', true);

    default:
      return defaultDialogReducer(state, action, dialogsNames.SLIT_ROLLS_TO_CASSETTES, defaultState);
  }

}

function _convertAssetDataToDialogItem(item = {}) {

  const {id, businessId, lengthLeft, widthInCentimeter: width, weight, material} = item;
  return {id, businessId, lengthLeft, width, weight, material}
}
